import * as React from 'react';
import {Box, ClickAwayListener, Link, MenuItem, Paper, Popper, Stack, Typography, useTheme} from '@mui/material';
import {Launch} from '@carbon/icons-react';

type Items = {
  title: string;
  link?: string;
  href?: string;
};

export interface Data {
  title: string;
  items: Array<Items>;
  callback?: (arg0: string) => void;
}

export const DropMenu = ({title, items, callback}: Data) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClickAway = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (title?: string, link?: string, href?: string) => {
    if (link) {
      window.open(link);
    } else if (href) {
      window.open(href, '_self');
    } else if (title && callback) {
      callback(title);
    }

    setAnchorEl(null);
  };
  const [pressed, setPressed] = React.useState<string>('');

  return (
    <>
      <Link
        variant='h5'
        fontWeight={400}
        color={open ? 'primary.main' : 'grey.900'}
        underline='none'
        onClick={handleClick}
        sx={{'&:hover': {color: 'primary.main'}, cursor: 'pointer'}}
        id='basic-Link'
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
      >
        {title}
      </Link>
      <Popper id={id} open={open} anchorEl={anchorEl} placement='bottom-start' disablePortal sx={{zIndex: 1000}}>
        <ClickAwayListener onClickAway={handleClickAway}>
          <Paper
            sx={{
              background: theme.palette.grey[200],
              boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)',
              marginTop: 1,
              p: 1.2,
              minWidth: '180px',
            }}
          >
            {items.map((item, index) => (
              <MenuItem
                id={item.title}
                onClick={() => handleClose(item.title, item.link, item.href)}
                key={index}
                sx={{
                  '&:hover': {color: 'grey.800', bgcolor: 'white'},
                  display: 'flex',
                  alignItems: 'center',

                  p: 0.8,
                }}
                onMouseDown={() => setPressed(item.title)}
                onMouseUp={() => setPressed('')}
                onMouseLeave={() => setPressed('')}
              >
                <Stack direction='row' spacing={1} alignItems='center' justifyContent='center' width='100%'>
                  <Box flexGrow={1} alignItems='flex-end' height='100%'>
                    <Typography
                      whiteSpace='normal'
                      maxWidth={item?.title?.length > 30 ? 180 : 'auto'}
                      variant='h5'
                      color={pressed === item.title ? theme.palette.primary.main : 'grey.800'}
                    >
                      <Stack alignItems='center' justifyContent='space-between' direction='row' columnGap='10px'>
                        {item.title}
                        {(item.link || item.href) && (
                          <Box width='20px' height='20px'>
                            <Launch color={'inherit'} height='20px' width='20px' />
                          </Box>
                        )}
                      </Stack>
                    </Typography>
                  </Box>
                </Stack>
              </MenuItem>
            ))}
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};
